// extracted by mini-css-extract-plugin
module.exports = {"button":"_3_7bM1","container":"_31Pb6j","mask":"_2qp0y5","text":"_3dj8zd","bold":"dlz-4Q","title":"_1f5UAA"};